function SelectionFilters() {
    return {
        startDate: null,
        endDate: null,
        subSurveyId: null,
        regions: []        
      }
}
export default SelectionFilters;